/* eslint-disable no-param-reassign */
import axios from 'axios';

const state = {
  orgs: [],
};

const getters = {
  getOrgs(st) {
    return st.orgs;
  },
  getOrgById: st => id => st.orgs.find(org => org.OrganizationId === id),
};

const mutations = {
  setOrgs(st, payload) {
    st.orgs = payload;
  },
};

const actions = {
  fetchOrgs({ commit }) {
    axios.get('organizations').then((r) => {
      commit('setOrgs', r.data);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/orgs.js